import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import './Header.css';

const Header: React.FC = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <header className="header">
      <div className="container header-content">
        <div className="header-brand">
          <Link to="/" className="header-logo">
            P&E Tools
          </Link>
        </div>
        <nav className="header-nav">
          <Link to="/" className="nav-link">Time Sheets</Link>
        </nav>
        <div className="header-user">
          {user && (
            <>
              <span className="user-name">{user.name || user.username}</span>
              <button className="btn btn-secondary" onClick={handleLogout}>
                Sign Out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
